var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,21c-.6,0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4V5c0-.6.2-1,.6-1.4s.9-.6,1.4-.6h16c.6,0,1,.2,1.4.6s.6.9.6,1.4v14c0,.6-.2,1-.6,1.4-.4.4-.9.6-1.4.6H4ZM5,17h5v-2h-5v2ZM14.6,15l5-5-1.4-1.4-3.5,3.6-1.4-1.4-1.4,1.4,2.8,2.8ZM5,13h5v-2h-5v2ZM5,9h5v-2h-5v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicIcon);
export default __webpack_public_path__ + "static/media/topic-icon.ae51bc9b2a27cb665d848d81e1be761c.svg";
export { ForwardRef as ReactComponent };